"use client"

import { useState } from "react"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import PDFUploader from "./components/PDFUploader"
import PDFList from "./components/PDFList"
import "./App.css"

function App() {
  const [pdfFiles, setPdfFiles] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleFileUpload = (files) => {
    const newFiles = Array.from(files).map((file, index) => ({
      id: `pdf-${Date.now()}-${index}`,
      file,
      name: file.name,
    }))

    setPdfFiles([...pdfFiles, ...newFiles])
  }

  const handleRemoveFile = (id) => {
    setPdfFiles(pdfFiles.filter((file) => file.id !== id))
  }

  const handleMoveFile = (dragIndex, hoverIndex) => {
    const draggedFile = pdfFiles[dragIndex]
    const updatedFiles = [...pdfFiles]
    updatedFiles.splice(dragIndex, 1)
    updatedFiles.splice(hoverIndex, 0, draggedFile)
    setPdfFiles(updatedFiles)
  }

  const handleClearAll = () => {
    setPdfFiles([])
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Blue header bar */}
      <div className="w-full bg-blue-500 py-4 px-6 flex justify-between items-center">
        <h1 className="text-xl font-medium text-white">Badkul Technology</h1>
        <button className="bg-white text-gray-800 px-4 py-1 rounded text-sm font-medium">PDF Merger</button>
      </div>

      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden my-8">
        <div className="p-8">
          <PDFUploader onFileUpload={handleFileUpload} />

          <DndProvider backend={HTML5Backend}>
            <PDFList
              files={pdfFiles}
              onRemoveFile={handleRemoveFile}
              onMoveFile={handleMoveFile}
              onClearAll={handleClearAll}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              error={error}
              setError={setError}
            />
          </DndProvider>
        </div>
      </div>

      {/* Blue footer bar */}
      <div className="w-full bg-blue-500 py-4 px-6 text-center text-white text-sm">
        © {new Date().getFullYear()} Badkul Technology PDF Merger. All rights reserved.
      </div>
    </div>
  )
}

export default App
